import React from 'react';
import { useTheme } from '@mui/material';
import DSBox from '../DSBox';
import DSTypography from '../Typography/DSTypography';
import DSTooltip from '../DSTooltip';
import { CalendarEvent } from '../../api/calendarEvent';
import {
  KLYDO_YELLOW,
  KLYDO_BLACK,
  KLYDO_WHITE,
  CALENDAR_EVENT_HOVER_BACKGROUND_COLOR,
} from '../../consts/colors';
import { isNationalHoliday } from '../../utils/calendarEvents';
import DSPlusButton from '../DSPlusButton';

type DSCalendarEventProps = {
  event: CalendarEvent;
  onClick: (event: CalendarEvent) => void;
  disabledClick: boolean;
};

const DSCalendarEvent = ({
  event,
  onClick,
  disabledClick: isPastDate,
}: DSCalendarEventProps) => {
  const { palette, spacing } = useTheme();

  const isNationalCalendarEventType = isNationalHoliday(event);
  const backgroundColor = isNationalCalendarEventType
    ? KLYDO_YELLOW
    : palette.secondary.light;
  const textColor = isNationalCalendarEventType ? KLYDO_BLACK : KLYDO_WHITE;
  const plusIconColor = isNationalCalendarEventType
    ? palette.secondary.dark
    : palette.action.active;
  const hoverBackgroundColor = isNationalCalendarEventType
    ? palette.primary.light
    : CALENDAR_EVENT_HOVER_BACKGROUND_COLOR;
  const hoverTextColor = isNationalCalendarEventType
    ? KLYDO_BLACK
    : palette.text.primary;

  return (
    <DSTooltip title={event.name} placement="top">
      <DSBox
        sx={{
          backgroundColor,
          borderRadius: '25px',
          padding: '2px 12px',
          marginBottom: spacing(0.5),
          overflow: 'hidden',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: spacing(0.5),
          width: '100%',
          '&:hover': {
            backgroundColor: hoverBackgroundColor,
            padding: '4px 12px',
            color: hoverTextColor,
          },
        }}
      >
        <DSTypography
          sx={{
            fontSize: '14px',
            fontFamily: 'Gilroy-Medium',
            color: textColor,
            lineHeight: '143%',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            width: '100%',
          }}
        >
          {event.name}
        </DSTypography>

        <DSPlusButton
          onClick={() => {
            if (isPastDate) return;
            onClick(event);
          }}
          disabled={isPastDate}
          size={16}
          color={plusIconColor}
        />
      </DSBox>
    </DSTooltip>
  );
};

export default DSCalendarEvent;
